import { authApi } from '../apis/auth';
import { User } from '../types/admin';
import { withNotification } from '../utils/notificationUtils';

// Interface cho đối tượng user
// export interface User {
//     id: string;
//     email: string;
//     name: string;
//     role: 'admin' | 'manager' | 'staff';
//     avatar?: string;
//     permissions: string[];
// }

// Service xác thực
const authService = {
    // Giả lập đăng nhập
    async login(email: string, password: string, remember?: boolean): Promise<{ user: User; token: string }> {
        try {
            const response = await authApi.login({ email, password });
            const { token, user } = response;

            // Lưu token dựa trên tùy chọn remember
            if (remember) {
                localStorage.setItem('auth_token', token);
            } else {
                sessionStorage.setItem('auth_token', token);
            }

            // Lưu dữ liệu người dùng
            const userData: User = {
                id: user.id,
                email: user.email,
                role: user.role,
                name: user.name // name có thể undefined
            };
            localStorage.setItem('user', JSON.stringify(userData));

            return { user: userData, token };
        } catch (error) {
            // Chuyển tiếp lỗi từ API
            throw error;
        }
    },

    // Đăng xuất
    async logout(): Promise<void> {
        return withNotification(
            async () => {
                // Perform logout API call if needed

                // Clear storage
                localStorage.removeItem('auth_token');
                sessionStorage.removeItem('auth_token');
                localStorage.removeItem('user');

                return Promise.resolve();
            },
            {
                showSuccessNotification: true,
                successMessage: 'Đăng xuất thành công',
                showErrorNotification: false
            }
        );
    },

    // Kiểm tra trạng thái đăng nhập
    isAuthenticated(): boolean {
        return !!localStorage.getItem('auth_token') || !!sessionStorage.getItem('auth_token');
    },

    // Lấy thông tin người dùng hiện tại
    getCurrentUser(): User | null {
        const userJson = localStorage.getItem('user');
        return userJson ? JSON.parse(userJson) : null;
    },

    // Lấy thông tin người dùng hiện tại từ API
    async fetchCurrentUser(): Promise<User> {
        return withNotification(
            async () => {
                if (!this.isAuthenticated()) {
                    throw new Error('Không có quyền truy cập');
                }

                try {
                    // Call the API to get current user if available
                    // const response = await authApi.getCurrentUser();
                    // return response;

                    // For now, get from localStorage
                    const user = this.getCurrentUser();
                    if (!user) {
                        throw new Error('Không tìm thấy thông tin người dùng');
                    }
                    return user;
                } catch (error) {
                    throw new Error('Không tìm thấy thông tin người dùng');
                }
            },
            {
                showSuccessNotification: false,
                errorMessage: 'Không thể lấy thông tin người dùng'
            }
        );
    },

    // Kiểm tra quyền của người dùng
    hasPermission(permission: string): boolean {
        const user = this.getCurrentUser();
        return user?.role === 'admin' || false;
    }
};

export default authService; 